module.exports = __webpack_public_path__ + "static/img/bg22.99fd9a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg22.jpg
// module id = 7mIa
// module chunks = 1